const avatars = [
    {
        memberName: "Hidayat Ullah",
        memberTitle: "Founder",
        memberImage: "images/hidayat_ullah.png",
        memberImageAlt: "An image of the founder of the company",
    },
    {
        memberName: "Sana Hidayat",
        memberTitle: "Operations Manager",
        memberImage: "/images/sana_hidayat.png",
        memberImageAlt: "An image of the CTO of the company",
    },
    {
        memberName: "Muhammad Ali",
        memberTitle: "Marketing Manager",
        memberImage: "/images/muhammad_ali.png",
        memberImageAlt: "An image of the marketing Manager of the company",
    }
]

export default avatars;